import MainPageWrapper from '../../global/components/MainPageWrapper'
import TabChooser from './TabChooser'
import CasesTable from '../../cases/components/table/CasesTable'
import DefectsDashboard from '../components/defects/DefectsDashboard'
import CarpetChart from '../components/carpet-chart/CarpetChart'
import { QUALITY_CONTROL_KEYS } from '../../global/constants/quality-control'

interface IQualityControlMainProps {
  tabType: QUALITY_CONTROL_KEYS
}

function QualityControlMain({ tabType }: IQualityControlMainProps) {
  let content: React.ReactElement | null = null

  switch (tabType) {
    case QUALITY_CONTROL_KEYS.casesTable:
      content = <CasesTable />
      break
    case QUALITY_CONTROL_KEYS.defects:
      content = <DefectsDashboard />
      break
    case QUALITY_CONTROL_KEYS.carpetChart:
      content = <CarpetChart />
      break
  }

  return (
    <MainPageWrapper title='Quality Control'>
      <TabChooser />
      {content}
    </MainPageWrapper>
  )
}

export default QualityControlMain
